const all = ['company'];

const findAll = (
  take?: number,
  skip?: number,
  search?: string,
  sort?: string
) => [...all, take, skip, search, sort];

const findOne = (newsId: string | undefined) => [...all, newsId];

export const keys = { all, findAll, findOne };
